/* tslint:disable:max-line-length */
import React from 'react'

interface Props {
    width?: number
    height?: number,
    fill?: string,
    stroke?: string
}

interface State {}

export default class CheckIcon extends React.Component<Props, State> {

    public render() {

        let {
            fill = '#FFF',
            stroke,
            width = 10,
            height = 6
        } = this.props

        return (
            <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
                <path stroke={stroke} fill={fill} fillRule="evenodd" d="M8.704.13L3.46 5 1.245 3.413a.487.487 0 0 0-.65.077.403.403 0 0 0-.09.318.42.42 0 0 0 .178.284l2.536 1.82a.487.487 0 0 0 .608-.037L9.36.736A.407.407 0 0 0 9.463.26.464.464 0 0 0 9.02 0a.48.48 0 0 0-.317.13z"/>
            </svg>
        )
    }
}



// WEBPACK FOOTER //
// ./src/_assets/icons/Check.tsx